import * as React from 'react';
// @ts-expect-error
import {DropTarget, ConnectDropTarget} from 'react-dnd';

import classnames from 'classnames';

import styles from './dash-slot.module.css';

const dashTarget = {
    // @ts-expect-error
    drop(props) {
        return {index: props.index};
    },
    // @ts-expect-error
    canDrop(props) {
        return props.isDropTarget;
    },
} as const;

type Props = {
    index?: number;
    containerQuery: any;
    isDropTarget?: boolean;
    onDashHover?: (...args: any) => any;
    children: React.ReactNode;
    // From react-dnd
    connectDropTarget: ConnectDropTarget;
    isOver: boolean;
    draggedItem: any;
};

type State = {
    isHoveredOverWithDash: boolean;
};

class DashSlotComponent extends React.Component<Props, State> {
    // @ts-expect-error
    constructor(props) {
        super(props);
        this.state = {
            isHoveredOverWithDash: false,
        };
    }

    // @ts-expect-error
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.onDashHover) {
            // Enter handler
            if (this.props.isDropTarget && !this.props.isOver && nextProps.isOver) {
                this.props.onDashHover({id: this.props.draggedItem.id, index: this.props.index});
                this.setState({isHoveredOverWithDash: true});
            }
            // Leave handler
            if (this.props.isDropTarget && this.props.isOver && !nextProps.isOver) {
                this.setState({isHoveredOverWithDash: false});
            }
        }
    }

    render() {
        // Wait for rendering until we know what size to make the card
        if (typeof this.props.containerQuery['card-wide'] === 'undefined') {
            return null;
        }

        const styleNames = classnames({
            [styles.slot]: true,
            [styles['slot-hovered']]: this.state.isHoveredOverWithDash,
            [styles['slot-wide']]:
                this.props.containerQuery && this.props.containerQuery['card-wide'],
        });

        return this.props.connectDropTarget(
            <div className={styleNames}>{this.props.children}</div>
        );
    }
}

// @ts-expect-error
export const DashSlot = DropTarget('dash', dashTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    draggedItem: monitor.getItem(),
}))(DashSlotComponent);
